import React from 'react'

const ListViewIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#5f6368"
    >
      <path d="M350-240h437.69q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-357H350v117ZM160-603h130v-117H172.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46V-603Zm0 187h130v-127H160v127Zm12.31 176H290v-117H160v104.69q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85ZM350-416h450v-127H350v127Zm0-187h450v-104.69q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H350v117ZM172.31-180Q142-180 121-201q-21-21-21-51.31v-455.38Q100-738 121-759q21-21 51.31-21h615.38Q818-780 839-759q21 21 21 51.31v455.38Q860-222 839-201q-21 21-51.31 21H172.31Z" />
    </svg>
  );
}

export default ListViewIcon